export enum ResolveConflictsStrategy {
  KeepAll,
  ReplaceAll,
  Manually,
}
